export function sendIFrameEvent(event, data) {
  window.parent.postMessage(
    {
      type: `3d-viewer:${event}`,
      payload: data,
    },
    '*',
  )
}
